import QueryUtils from '../query';

export default class UserRequests {
    constructor(appmixerApi) {
        this.api = appmixerApi;
    }
    authenticateUser(username, password) {
        return this.api.authenticateUser(username, password);
    }

    queryAuthUser() {
        return this.api.getUser();
    }

    queryUser(userId) {
        return this.api.request({
            url: `${this.api.get('baseUrl')}/users/${userId}`,
            method: 'GET'
        });
    }

    queryUsers(query = {}) {
        query = QueryUtils.processQuery(query);
        return this.api.request({
            url: `${this.api.get('baseUrl')}/users`,
            method: 'GET',
            params: query
        });
    }

    queryUsersCount(query = {}) {
        query = QueryUtils.processQuery(query);
        return this.api.request({
            url: `${this.api.get('baseUrl')}/users/count`,
            method: 'GET',
            params: query
        });
    }

    updateUser(userId, payload) {
        return this.api.request({
            url: `${this.api.get('baseUrl')}/users/${userId}`,
            method: 'PUT',
            data: payload
        });
    }

    removeUser(userId) {
        return this.api.request({
            url: `${this.api.get('baseUrl')}/users/${userId}`,
            method: 'DELETE'
        });
    }

    removeStatus(userId, ticket) {
        return this.api.request({
            url: `${this.api.get('baseUrl')}/users/${userId}/delete-status/${ticket}`,
            method: 'GET'
        });
    }
};
